/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MembershipFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 4V20H1V4H23ZM8.14195 8C7.02756 8 5.99739 8.38565 5.24112 9.08608C4.42911 9.83782 4 10.8774 4 12.0922C4 14.5015 5.78613 16.1843 8.34367 16.1843C9.75772 16.1843 10.7625 15.6652 11.3578 15.228V13.3331C10.4759 14.0118 9.44643 14.4006 8.52903 14.4006C7.06188 14.4006 6.03713 13.4177 6.03713 12.0102C6.03713 10.6706 6.97182 9.73489 8.31014 9.73489C8.74392 9.73489 9.12185 9.84081 9.52204 9.95277C9.93582 10.0692 10.3635 10.1894 10.8779 10.1894C11.0385 10.1894 11.1956 10.1782 11.3578 10.1552V8.33984C11.2247 8.35467 11.0928 8.36191 10.9554 8.36191C10.4927 8.36191 10.077 8.27805 9.6369 8.18912C9.17586 8.09612 8.69969 8 8.14195 8ZM20 14.25H14V15.75H20V14.25ZM20 11.25H14V12.75H20V11.25ZM20 8.25H14V9.75H20V8.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
